var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable complexity */
import { processBreaksDuringWorkIndicatorData, processChartData, processChatActivityBreakdownData, processChatResponseSpeedAndFrequencyData, processChatRoomsByMessageVolumeData, processChatSummaryData, processCollaborativeTimeData, processCommunicationByChannelData, processCommunicationByLabelData, processCommunicationByPeerTypeData, processCommunicationByWeekdaysData, processConsistencyOfAttendanceInMeetsData, processCreatedAndOwnedFilesData, processCreatedItemsByActivityLabelData, processCreatedItemsByTypeData, processDaysWithExtendedWorkHoursData, processDocReviewCountData, processDocsSharedExternallyByLabelData, processDocsSharedExternallyData, processDocumentAlertsChartData, processDocumentAlertsData, processDocumentFileSummaryData, processDocumentPeopleActivity, processDocumentReportData, processDriveActionsOverTimeData, processDriveDocumentsActivityData, processDriveSummaryData, processEmailSummaryReplyRateData, processEventsData, processGeminiActionBreakdownData, processGeminiAdoptionTrendData, processGeminiSummaryData, processGeminiUsageCategoryByAppData, processGeminiUsageLevelDistributionData, processGeminiUserSummaryData, processGmailActionsOverTimeData, processGmailSummaryData, processHeatmapData, processIndividualCommTimeData, processInitiatedCommunicationData, processInvocationsByActionData, processInvocationsByAppData, processInvocationsByUserData, processMeetingLoadAnalyticData, processMeetingsBackToBackAnalyticData, processMeetingsByLengthAnalyticData, processMeetingsByScheduleAnalyticData, processMeetingsBySizeAnalyticData, processMeetingsByTimePeriodData, processMeetingsByWhenAnalyticData, processMeetingsByWhoAttendedAnalyticData, processMeetingsPlannedVsActualAnalyticData, processMeetingsTypesData, processMeetSummaryData, processMeetSummaryTableData, processMeetUsersTimelineData, processMostFrequentCommunicationPartnersData, processMostPopularDocumentsData, processPlannedVSAdHocMeetingsData, processReceivedCommunicationData, processScheduledMeetAttendanceRateData, processSharedFilesData, processTimelineData, processTimeSpentByActivityTypeData, processTimeSpentOnActivitiesData, processTimeSpentOnWorkActivitiesUserChartData, processTopChattersData, processTopRecurringEventsAndMeetingsData, processUserActivityOnResolvingData, processUserActivitySummary, processUserDriveActivity, processWorkdayAlignmentData, processWorkingTimeAllocationByLabelData, processWorkLocationBreakdownData } from '@workalizer/generative-ai/src/lib/generative-ai/utils/dataProcessors';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { format } from 'date-fns';
import i18n from 'i18next';
import { zodToJsonSchema } from 'zod-to-json-schema';
export var generateQueryFromTable = function (data, categories, insightType, insightTitle) {
    if (insightType === void 0) { insightType = InsightTypeEnum.data; }
    return __awaiter(void 0, void 0, void 0, function () {
        var summary, communicationData, peerTypeData, meetingsByTimePeriodData, workingTimeData, prompt;
        return __generator(this, function (_a) {
            summary = [];
            switch (insightType) {
                case InsightTypeEnum.timeSpentOnWorkActivities:
                    if (typeof data === 'object' &&
                        data !== null &&
                        !Array.isArray(data) &&
                        'periods' in data) {
                        summary = processTimeSpentOnWorkActivitiesUserChartData(data.periods);
                    }
                    else {
                        summary = processChartData(data, categories);
                    }
                    break;
                case InsightTypeEnum.gmailActivity:
                case InsightTypeEnum.driveActivity:
                case InsightTypeEnum.meetActivity:
                case InsightTypeEnum.chatActivity:
                case InsightTypeEnum.chatChart:
                    summary = processChartData(data, categories);
                    break;
                case InsightTypeEnum.timeSpentByActivityType:
                    if (typeof data === 'object' &&
                        data !== null &&
                        !Array.isArray(data) &&
                        'current' in data &&
                        'previous' in data) {
                        summary = processTimeSpentByActivityTypeData(data);
                    }
                    else {
                        summary = processUserActivitySummary(data);
                    }
                    break;
                case InsightTypeEnum.activitySummaryHeatmap:
                case InsightTypeEnum.documentReport:
                    summary = processDocumentReportData(data);
                    break;
                case InsightTypeEnum.dailyTimeline:
                case InsightTypeEnum.documentDailyTimeline:
                case InsightTypeEnum.documentEventsLog:
                    summary = processTimelineData(data);
                    break;
                case InsightTypeEnum.userHeatmap:
                case InsightTypeEnum.documentActivity:
                    summary = processHeatmapData(data);
                    break;
                case InsightTypeEnum.userDriveActivity:
                    summary = processUserDriveActivity(data);
                    break;
                case InsightTypeEnum.meetingsTypes:
                    summary = processMeetingsTypesData(data);
                    break;
                case InsightTypeEnum.docAlertsTable:
                    summary = processDocumentAlertsData(data);
                    break;
                case InsightTypeEnum.eventsTable:
                    summary = processEventsData(data);
                    break;
                case InsightTypeEnum.documentPeopleActivity:
                    summary = processDocumentPeopleActivity(data);
                    break;
                case InsightTypeEnum.documentFileSummary:
                    summary = processDocumentFileSummaryData(data);
                    break;
                case InsightTypeEnum.meetUsersTimeline:
                    summary = processMeetUsersTimelineData(data);
                    break;
                case InsightTypeEnum.meetSummaryTable:
                    summary = processMeetSummaryTableData(data);
                    break;
                case InsightTypeEnum.docAlertsChart:
                    summary = processDocumentAlertsChartData(data);
                    break;
                case InsightTypeEnum.createdItemsByType:
                    summary = processCreatedItemsByTypeData(data);
                    break;
                case InsightTypeEnum.mostPopularDocuments:
                    summary = processMostPopularDocumentsData(data);
                    break;
                case InsightTypeEnum.createdItemsByActivityLabel:
                    summary = processCreatedItemsByActivityLabelData(data);
                    break;
                case InsightTypeEnum.topRecurringEventsAndMeetings:
                    summary = processTopRecurringEventsAndMeetingsData(data);
                    break;
                case InsightTypeEnum.userActivityOnResolving:
                    summary = processUserActivityOnResolvingData(data);
                    break;
                case InsightTypeEnum.docReviewCount:
                    summary = processDocReviewCountData(data);
                    break;
                case InsightTypeEnum.userInitiatedCommunication:
                    summary = processInitiatedCommunicationData(data);
                    break;
                case InsightTypeEnum.userReceivedCommunication:
                    summary = processReceivedCommunicationData(data);
                    break;
                case InsightTypeEnum.emailSummaryReplyRate:
                    summary = processEmailSummaryReplyRateData(data);
                    break;
                case InsightTypeEnum.sentVsReceivedEmailsAndChatsRatio:
                    summary = processCommunicationByChannelData(data);
                    break;
                case InsightTypeEnum.communicationByActivityLabel:
                    communicationData = data;
                    summary = communicationData.flatMap(function (item) {
                        return processCommunicationByLabelData(item);
                    });
                    break;
                case InsightTypeEnum.communicationByPeerType:
                    peerTypeData = data;
                    summary = peerTypeData.flatMap(function (item) {
                        return processCommunicationByPeerTypeData(item);
                    });
                    break;
                case InsightTypeEnum.employeeMeetingsByTimePeriod:
                    meetingsByTimePeriodData = data;
                    summary = meetingsByTimePeriodData.flatMap(function (item) {
                        return processMeetingsByTimePeriodData(item);
                    });
                    break;
                case InsightTypeEnum.mostFrequentCommunicationPartners:
                    summary = processMostFrequentCommunicationPartnersData(data);
                    break;
                case InsightTypeEnum.communicationDistributionByWeekdays:
                    summary = processCommunicationByWeekdaysData(data);
                    break;
                case InsightTypeEnum.chatRoomsByMessageVolume:
                    summary = processChatRoomsByMessageVolumeData(data);
                    break;
                case InsightTypeEnum.collaborativeTime:
                    summary = processCollaborativeTimeData(data);
                    break;
                case InsightTypeEnum.chatResponseSpeedAndFrequency:
                    summary = processChatResponseSpeedAndFrequencyData(data);
                    break;
                case InsightTypeEnum.emailResponseSpeedAndFrequency:
                    summary = processChatResponseSpeedAndFrequencyData(data);
                    break;
                case InsightTypeEnum.topChatters:
                    summary = processTopChattersData(data);
                    break;
                case InsightTypeEnum.consistencyOfAttendanceInMeets:
                    summary = processConsistencyOfAttendanceInMeetsData(data);
                    break;
                case InsightTypeEnum.plannedVSAdHocMeetings:
                    summary = processPlannedVSAdHocMeetingsData(data);
                    break;
                case InsightTypeEnum.gmailActionsOverTime:
                    summary = processGmailActionsOverTimeData(data);
                    break;
                case InsightTypeEnum.meetingLoadAnalytic:
                    summary = processMeetingLoadAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsBySizeAnalytic:
                    summary = processMeetingsBySizeAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsByLengthAnalytic:
                    summary = processMeetingsByLengthAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsByScheduleAnalytic:
                    summary = processMeetingsByScheduleAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsBackToBackAnalytic:
                    summary = processMeetingsBackToBackAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsByWhenAnalytic:
                    summary = processMeetingsByWhenAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsByWhoAttendedAnalytic:
                    summary = processMeetingsByWhoAttendedAnalyticData(data);
                    break;
                case InsightTypeEnum.meetingsPlannedVsActualAnalytic:
                    summary = processMeetingsPlannedVsActualAnalyticData(data);
                    break;
                case InsightTypeEnum.gmailSummary:
                    summary = processGmailSummaryData(data);
                    break;
                case InsightTypeEnum.driveSummary:
                    summary = processDriveSummaryData(data);
                    break;
                case InsightTypeEnum.chatSummary:
                    summary = processChatSummaryData(data);
                    break;
                case InsightTypeEnum.geminiSummary:
                    summary = processGeminiSummaryData(data);
                    break;
                case InsightTypeEnum.geminiUserSummary:
                    summary = processGeminiUserSummaryData(data);
                    break;
                case InsightTypeEnum.geminiAdoptionTrend:
                    summary = processGeminiAdoptionTrendData(data);
                    break;
                case InsightTypeEnum.geminiUsageLevelDistribution:
                    summary = processGeminiUsageLevelDistributionData(data);
                    break;
                case InsightTypeEnum.geminiUsageCategoryByApp:
                    summary = processGeminiUsageCategoryByAppData(data);
                    break;
                case InsightTypeEnum.geminiActionBreakdown:
                    summary = processGeminiActionBreakdownData(data);
                    break;
                case InsightTypeEnum.meetSummary:
                    summary = processMeetSummaryData(data);
                    break;
                case InsightTypeEnum.chatActivityBreakdown:
                    summary = processChatActivityBreakdownData(data);
                    break;
                case InsightTypeEnum.driveActionsOverTime:
                    summary = processDriveActionsOverTimeData(data);
                    break;
                case InsightTypeEnum.driveDocumentsActivity:
                    summary = processDriveDocumentsActivityData(data);
                    break;
                case InsightTypeEnum.workdayAlignmentWithTeam:
                    summary = processWorkdayAlignmentData(data);
                    break;
                case InsightTypeEnum.createdAndOwnedFiles:
                    summary = processCreatedAndOwnedFilesData(data);
                    break;
                case InsightTypeEnum.filesSharedByEmployee:
                    summary = processSharedFilesData(data);
                    break;
                case InsightTypeEnum.timeSpentOnIndependentWorkActivities:
                    summary = processTimeSpentOnActivitiesData(data);
                    break;
                case InsightTypeEnum.managerIndividualCommTime:
                    summary = processIndividualCommTimeData(data);
                    break;
                case InsightTypeEnum.invocationsByApp:
                    summary = processInvocationsByAppData(data);
                    break;
                case InsightTypeEnum.invocationsByAction:
                    summary = processInvocationsByActionData(data);
                    break;
                case InsightTypeEnum.invocationsByUser:
                    summary = processInvocationsByUserData(data);
                    break;
                case InsightTypeEnum.breaksDuringWorkIndicator:
                    summary = processBreaksDuringWorkIndicatorData(data);
                    break;
                case InsightTypeEnum.daysWithExtendedWorkHours:
                    summary = processDaysWithExtendedWorkHoursData(data);
                    break;
                case InsightTypeEnum.workingTimeAllocationByLabel:
                    workingTimeData = data;
                    summary = workingTimeData.flatMap(function (item) {
                        return processWorkingTimeAllocationByLabelData(item);
                    });
                    break;
                case InsightTypeEnum.docsSharedExternally:
                    summary = processDocsSharedExternallyData(data);
                    break;
                case InsightTypeEnum.docsSharedExternallyByLabel:
                    summary = processDocsSharedExternallyByLabelData(data);
                    break;
                case InsightTypeEnum.scheduledMeetAttendanceRate:
                    summary = processScheduledMeetAttendanceRateData(data);
                    break;
                case InsightTypeEnum.workdayAlignmentWithTeam:
                    summary = processWorkdayAlignmentData(data);
                    break;
                case InsightTypeEnum.workLocationBreakdown:
                    summary = processWorkLocationBreakdownData(data);
                    break;
                default:
                    throw new Error("Unsupported insightType: ".concat(insightType));
            }
            prompt = "\n  You are a team manager now. I would appreciate your help analyzing the data.\n  Based on the data in the \"".concat(i18n.t("insights.tables.".concat(insightType)), "\" table below, provide insights, identify trends, and suggest potential actions:\n\n  ").concat(summary.join('\n'), "\n\n  Here are the filters that were applied by the user to generate the data table: ").concat(insightTitle, ".\n  Please provide your response in a step-by-step format. Be specific in identifying patterns and providing suggestions for improving team efficiency.\n");
            return [2 /*return*/, prompt];
        });
    });
};
export var getInsightTitle = function (_a) {
    var _b, _c;
    var filters = _a.filters, context = _a.context, insightType = _a.insightType;
    var orgUnits = context.orgUnits, users = context.users;
    var user = filters.user, orgUnit = filters.orgUnit, dateFrom = filters.dateFrom, dateTo = filters.dateTo;
    var includeDates = insightType !== InsightTypeEnum.userHeatmap &&
        insightType !== InsightTypeEnum.documentActivity &&
        insightType !== InsightTypeEnum.documentDailyTimeline &&
        insightType !== InsightTypeEnum.documentEventsLog &&
        insightType !== InsightTypeEnum.documentPeopleActivity &&
        insightType !== InsightTypeEnum.documentFileSummary &&
        insightType !== InsightTypeEnum.meetUsersTimeline &&
        insightType !== InsightTypeEnum.meetSummaryTable &&
        insightType !== InsightTypeEnum.dailyTimeline;
    return [
        "".concat(i18n.t("insights.tables.".concat(insightType))),
        orgUnit
            ? "".concat(i18n.t('OrgUnit'), " ").concat((_b = orgUnits.find(function (ou) { return ou.id === orgUnit; })) === null || _b === void 0 ? void 0 : _b.title)
            : null,
        user ? "".concat(i18n.t('User'), " ").concat((_c = users.find(function (u) { return u.id === user; })) === null || _c === void 0 ? void 0 : _c.name) : null,
        includeDates && dateFrom ? format(dateFrom, 'd MMM yyyy') : null,
        includeDates && dateTo ? format(dateTo, 'd MMM yyyy') : null
    ].filter(Boolean);
};
export function generateSystemInstruction(schema, additionalContext) {
    var jsonSchema = zodToJsonSchema(schema, 'ResponseSchema');
    var instruction = "\n    You are an AI assistant that responds with structured JSON data.\n    CRITICAL: You must respond with ACTUAL DATA, NOT the schema shown below!\n    The schema below shows the STRUCTURE you must follow, but you need to return real data:\n    SCHEMA FOR REFERENCE (DO NOT RETURN THIS):\n    ".concat(JSON.stringify(jsonSchema, null, 2), "\n    EXAMPLE of what you should return (actual data following the schema structure):\n    If the schema expects an array of objects with \"name\" and \"rules\", return something like:\n    [\n      {\n        \"name\": \"Example Label Name\",\n        \"rules\": [/* actual rule objects */]\n      }\n    ]\n  ").trim();
    if (additionalContext) {
        instruction += "\n\n".concat(additionalContext);
    }
    instruction += "\n    STRICT REQUIREMENTS:\n    - Return ONLY the JSON data (the content, not the schema)\n    - Do NOT return the schema shown above\n    - Do NOT include explanations or extra text\n    - Must be valid, parseable JSON\n    - Follow the exact structure shown in the schema\n    - Use real, meaningful data that matches the schema format\n  ";
    return instruction;
}
